import { Trans } from '@lingui/react/macro';

import type { VendorAndChannelType } from '@/api/vendor';
import { ColorBadge } from '@/components/typography';
import { getChannelColor } from '@/constants/colors/channel';

type Props = {
  vendors?: VendorAndChannelType[];
};

const VendorTagList = ({ vendors }: Props) => {
  return (
    <div className="flex flex-wrap justify-end gap-1">
      {vendors?.map((vendor) => {
        const vendorColor = getChannelColor(vendor.channel, 0.5);

        return (
          <ColorBadge
            key={vendor.id}
            size="medium"
            variant="solid"
            color={vendorColor}
            textColor="dark"
          >
            <Trans>
              {vendor.name} - {vendor.channel?.name}
            </Trans>
          </ColorBadge>
        );
      })}
    </div>
  );
};

export default VendorTagList;
